import { Observable } from 'rxjs';

export interface AllotmentQuarterForm {
  aa_id: string | number,
  aqb_quarter: string | number,
  aqb_amount: string | number,
  aqb_date: any,
  aro_number: string,
  is_research: number,
  s_budget: string,
  fromAaId: string | number
}

export interface ApiResponse {
  code: number,
  message: any
}

export abstract class AllotmentData {
  abstract save(form: AllotmentQuarterForm): Observable<ApiResponse>;
  abstract update(form: AllotmentQuarterForm): Observable<ApiResponse>;
  abstract getByAccountAndQuarter(page: number, page_size: number, id: number, quarter: number): Observable<ApiResponse>;
  abstract delete(id: number): Observable<ApiResponse>;
}
